var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dashboard-widget",
    { staticClass: "vendor-address", attrs: { padding: 24, title: _vm.title } },
    [
      _c(
        "div",
        { staticClass: "address-info", on: { click: _vm.editAddress } },
        [
          _c("el-skeleton", { attrs: { animated: "", loading: _vm.loading } }, [
            _c("strong", [_vm._v(_vm._s(_vm.address.vendorRegisteredName))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.address.locationName))]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.address.cityName) +
                  ", " +
                  _vm._s(_vm.address.regionName)
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.address.countryName))])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }